import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const phcolumn = [
  {
    field: "donvi",
    headerName: "Đơn vị",
    width: 270,
    headerAlign: "center",
  },
  {
    field: "dmloaihinhvantai",
    headerName: "Loại hình",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "sodangky",
    headerName: "Số đăng ký",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "sophuhieu",
    headerName: "Số phù hiệu",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "ngaycap",
    headerName: "Ngày cấp",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "phuhieu",
    headerName: "Phù hiệu",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "mauphuhieu",
    headerName: "Mẫu phù hiệu",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "succhua",
    headerName: "Sức chứa",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "taitrong",
    headerName: "Tải trọng",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "trangthai",
    headerName: "Trạng thái",
    width: 150,
    headerAlign: "center",
  },
];

export default function Hethanphuhieu() {
  const [pageSize, setPageSize] = React.useState(50);
  const [phuhieu, setPhuhieu] = React.useState([]);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getcanhbaophuhieu = () => {
    var url =
      Config.backend + "/api/canhbao/canhbaophuhieuxe?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuhieu(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getcanhbaophuhieu();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={phuhieu}
            columns={phcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
